import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { setSpaceAfterNLetter, trans } from "../../../helpers/index";
import ApiManager from "../../../apiManager";
import ErrorModal from "../../Fragments/ErrorModal";
import Select from "react-select";
import FormMiddlewareError from "../../Fragments/FormMiddlewareError";
import Modal from "../../Fragments/Modal";
import Tab from "../../Fragments/Tab";
import Loading from "../../Fragments/Loading";
import { localStorageGetItem } from "../../../storage";
import config from "../../../baseConfig";

class AutoPayment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // agreeWithTerms: false,
      buttonDisabled: false,
      buttonDeleteDisabled: false,
      accountLimit: null,
      showErrorModal: false,
      successModal: false,
      autoPaymentNumbersList: "",
      autoPaymentCardList: "",
      numbersSelected: null,
      cardSelected: null,
      autoPaymentName: "",
      autoPaymentComplement: "",
      autoPaymentMaxLimit: "",
      autoPaymentServices: "",
      autoPaymentTabIndex: 0,
      formResponse: "",
      daysTabShow: false,
      rechargeDate: trans(
        this.props.trans,
        "autopayment.form_add.recharge_date_placeholder"
      ),
      isPostpaid: null,
      confirmDeleteModalShow: false,
    };

    this.componentIsMounted = true;
    this.documentClickFn = null;
    this.daysListRef = React.createRef();
    this.autoPaymentNumbersListSuccess =
      this.autoPaymentNumbersListSuccess.bind(this);
    this.autoPaymentCardListSuccess =
      this.autoPaymentCardListSuccess.bind(this);
    this.autoPaymentGetBillingTypeSuccess =
      this.autoPaymentGetBillingTypeSuccess.bind(this);
    this.autoPaymentServicesSuccess =
      this.autoPaymentServicesSuccess.bind(this);
    this.getEditableNumberDetailsSuccess =
      this.getEditableNumberDetailsSuccess.bind(this);
    // this.resetForm = this.resetForm.bind( this );
    this.errorCallBack = this.errorCallBack.bind(this);
  }

  componentDidMount() {
    this.initDocumentEvent();

    // Get profile payment card list
    ApiManager.getRequest(
      {
        jwt: this.props.getDecryptedToken(),
      },
      "/payment/card/list"
    ).then(this.autoPaymentCardListSuccess, this.errorCallBack);

    // Auto payment numbers
    ApiManager.getRequest(
      {
        jwt: this.props.getDecryptedToken(),
      },
      "/autopayment/numbers"
    ).then(this.autoPaymentNumbersListSuccess, this.errorCallBack);

    // Auto payment numbers
    ApiManager.getRequest(
      {
        jwt: this.props.getDecryptedToken(),
      },
      "/autopayment/services"
    ).then(this.autoPaymentServicesSuccess, this.errorCallBack);
  }

  componentWillUnmount() {
    this.componentIsMounted = false;
    document.removeEventListener("click", this.documentClickFn, false);
  }

  initDocumentEvent() {
    this.documentClickFn = (event) => {
      if (!event.target.closest(".form__field-out--days")) {
        this.setState({ daysTabShow: false });
      }
    };

    // Hide account
    document.addEventListener("click", this.documentClickFn, false);
  }

  getNumberBillingType(number) {
    // Get number billing id
    ApiManager.getRequest(
      {
        jwt: this.props.getDecryptedToken(),
        number,
      },
      "/autopayment/check-number"
    ).then(this.autoPaymentGetBillingTypeSuccess, this.errorCallBack);
  }

  autoPaymentGetBillingTypeSuccess(resolve) {
    if (!this.componentIsMounted) {
      return;
    }

    this.setState({
      isPostpaid: resolve.data.data.billing_type === "postpaid",
    });
  }

  autoPaymentServicesSuccess(resolve) {
    if (!this.componentIsMounted) {
      return;
    }

    this.setState(
      {
        autoPaymentServices: resolve.data,
      },
      () =>
        this.setState({
          accountLimit: this.limitOptions()[0],
        })
    );
  }

  numberOptions(autoPaymentNumbersList) {
    let data = [];

    if (
      autoPaymentNumbersList !== "" &&
      autoPaymentNumbersList.status === "OK"
    ) {
      data = autoPaymentNumbersList.data.numbers.map(({ number }) => {
        return {
          value: number,
          label: "+374 " + setSpaceAfterNLetter(number, 2),
        };
      });
    }

    return data;
  }

  cardOptions(autoPaymentCardList) {
    let data = [];

    if (autoPaymentCardList !== "" && autoPaymentCardList.status === "OK") {
      data = autoPaymentCardList.data.cards.map((item) => {
        return {
          value: item.id,
          label: item.pan,
        };
      });
    }

    return data;
  }

  limitOptions() {
    let data = [];

    if (
      this.state.autoPaymentServices !== "" &&
      this.state.autoPaymentServices.status === "OK"
    ) {
      data = this.state.autoPaymentServices.data.prepaid.limits.map(
        ({ id, threshold }) => {
          return {
            value: id,
            label: threshold + " ֏",
          };
        }
      );
    }

    return data;
  }

  autoPaymentNumbersListSuccess(resolve) {
    if (!this.componentIsMounted) {
      return;
    }

    // @test
    // resolve.data = { "status": "OK", "data": { "numbers": [ { "id": 0, "name": "", "number": "91013528" } ] } };

    this.setState({
      autoPaymentNumbersList: this.numberOptions(resolve.data),
    });

    if (this.props.edit) {
      this.getEditableNumberDetails();
    } else if (this.state.autoPaymentNumbersList.length) {
      this.setState({
        numbersSelected: this.state.autoPaymentNumbersList[0],
      });

      this.getNumberBillingType(this.state.autoPaymentNumbersList[0]["value"]);
    }
  }

  autoPaymentCardListSuccess(resolve) {
    if (!this.componentIsMounted) {
      return;
    }

    const cardOptions = this.cardOptions(resolve.data);

    this.setState(
      {
        autoPaymentCardList: cardOptions,
      },
      () => {
        if (cardOptions.length && !this.props.edit) {
          this.setState({
            cardSelected: cardOptions[0],
          });
        }
      }
    );

    this.getEditableNumberDetails();
  }

  getEditableNumberDetails() {
    // Auto payment numbers
    ApiManager.getRequest(
      {
        jwt: this.props.getDecryptedToken(),
        id: localStorageGetItem("editAutoPaymentId"),
      },
      "/autopayment/get"
    ).then(this.getEditableNumberDetailsSuccess, this.errorCallBack);
  }

  getEditableNumberDetailsSuccess(resolve) {
    if (!this.componentIsMounted) {
      return;
    }

    if (resolve.data.status === "OK") {
      const result = resolve.data.data.autopayment;
      const phoneNumber = this.state.autoPaymentNumbersList.filter(
        ({ value }) => value === result.phone_number
      );
      const cardId = this.state.autoPaymentCardList.filter(
        ({ value }) => value === result.card_id
      );
      const serviceId = this.limitOptions().filter(
        ({ value }) => value === result.service_id
      );

      this.setState({
        numbersSelected: phoneNumber[0],
        cardSelected: cardId[0],
        autoPaymentName: result.name,
        rechargeDate:
          result.day ||
          trans(
            this.props.trans,
            "autopayment.form_add.recharge_date_placeholder"
          ),
        autoPaymentMaxLimit: result.amount,
        autoPaymentComplement: result.amount,
        accountLimit: serviceId[0],
        autoPaymentTabIndex: result.day !== null ? 1 : 0,
      });

      this.getNumberBillingType(phoneNumber[0]["value"]);
    }
  }

  errorCallBack(reject) {
    this.setState({ showErrorModal: true });
  }

  errorModal() {
    if (!this.state.showErrorModal) {
      return "";
    }

    return (
      <ErrorModal
        title={trans(this.props.trans, "error.modal.title")}
        description={trans(this.props.trans, "error.modal.description")}
        action_text={trans(this.props.trans, "error.modal.action_text")}
      />
    );
  }

  handleSelectChange(newState, current) {
    let selectState = {};

    selectState[current] = newState;

    if (
      current === "numbersSelected" &&
      newState["value"] !== this.state.numbersSelected["value"]
    ) {
      // accountLimit: null,
      // cardSelected: null,
      // autoPaymentServices: '',

      selectState["isPostpaid"] = null;
      selectState["formResponse"] = "";
      selectState["autoPaymentTabIndex"] = 0;
      selectState["autoPaymentMaxLimit"] = "";
      selectState["autoPaymentComplement"] = "";
      selectState["autoPaymentName"] = "";
      selectState["rechargeDate"] = trans(
        this.props.trans,
        "autopayment.form_add.recharge_date_placeholder"
      );
      selectState["cardSelected"] =
        this.state.autoPaymentCardList.length &&
        this.state.autoPaymentCardList[0];
      selectState["accountLimit"] =
        this.limitOptions().length && this.limitOptions()[0];

      this.getNumberBillingType(newState["value"]);
    }

    this.setState(selectState);
  }

  reSendData(isDelete) {
    this.setState({ buttonDisabled: true });

    ApiManager.getRequest({}, "/csrf-token").then(
      (resolve) => {
        this.props.setTokenAction(resolve.data);
        if (isDelete) {
          this.deleteAutoPayment();
        } else {
          this.sendData();
        }
      },
      (reject) => {
        this.setState({ showErrorModal: true });
      }
    );
  }

  sendData() {
    this.setState({ buttonDisabled: true });

    let service_id = "",
      day = this.state.rechargeDate,
      id = "",
      url = "/autopayment/add";

    if (
      this.state.autoPaymentServices !== "" &&
      this.state.autoPaymentServices.status === "OK"
    ) {
      service_id = this.state.autoPaymentServices.data.postpaid.date_service_id;

      if (!this.state.isPostpaid) {
        if (this.state.autoPaymentTabIndex === 0) {
          service_id = this.state.accountLimit && this.state.accountLimit.value;
          day = "";
        } else {
          service_id =
            this.state.autoPaymentServices.data.prepaid.date_service_id;
        }
      }
    }

    if (this.props.edit) {
      id = localStorageGetItem("editAutoPaymentId");
      url = "/autopayment/update";
    }

    ApiManager.postRequest(
      {
        jwt: this.props.getDecryptedToken(),
        _token: this.props.csrf_token.data,
        card_id: this.state.cardSelected && this.state.cardSelected.value,
        name: this.state.autoPaymentName,
        phone_number:
          this.state.numbersSelected && this.state.numbersSelected.value,
        amount: this.state.isPostpaid
          ? this.state.autoPaymentMaxLimit
          : this.state.autoPaymentComplement,
        day,
        service_id,
        id,
      },
      url
    ).then((resolve) => {
      if (!this.componentIsMounted) {
        return;
      }

      this.setState({
        buttonDisabled: false,
        formResponse: resolve.data,
      });

      if (resolve.data.status === "OK") {
        this.setState({
          successModal: true,
        });
      } else if (resolve.data.status === "CSRF_TOKEN_MISMATCH") {
        this.reSendData();
      }
    }, this.errorCallBack);
  }

  deleteAutoPayment() {
    this.setState({ buttonDeleteDisabled: true });

    ApiManager.postRequest(
      {
        jwt: this.props.getDecryptedToken(),
        _token: this.props.csrf_token.data,
        id: localStorageGetItem("editAutoPaymentId"),
      },
      "/autopayment/delete"
    ).then((resolve) => {
      if (!this.componentIsMounted) {
        return;
      }

      this.setState({
        buttonDeleteDisabled: false,
      });

      if (resolve.data.status === "OK") {
        this.props.history.push(
          config.urlPrefix + this.props.parentState.urlPrefix + "/account"
        );
      } else if (resolve.data.status === "CSRF_TOKEN_MISMATCH") {
        this.reSendData(true);
      }
    }, this.errorCallBack);
  }

  /*
    resetForm(){

        this.setState({
            accountLimit: this.limitOptions()[0],
            // agreeWithTerms: false,
            successModal: false,
            numbersSelected: this.numberOptions()[0],
            cardSelected: null,
            autoPaymentName: '',
            autoPaymentComplement: '',
            autoPaymentMaxLimit: '',
            rechargeDate: trans(this.props.trans, 'autopayment.form_add.recharge_date_placeholder'),
            isPostpaid: 'postpaid',
            formResponse: ''
        });

    }
    */

  daysTab() {
    if (!this.state.daysTabShow) {
      return "";
    }

    return (
      <ul className="form__date-list pa scroller-block" ref={this.daysListRef}>
        {[...Array(28).keys()].map((item) => (
          <li
            className={`form__date-item fs13 trans-background${
              item + 1 === this.state.rechargeDate
                ? " form__date-item--active"
                : ""
            }`}
            key={item}
            onClick={() =>
              this.setState({
                daysTabShow: false,
                rechargeDate: item + 1,
              })
            }
          >
            {item + 1}
          </li>
        ))}
      </ul>
    );
  }

  confirmDeleteModal() {
    if (!this.state.confirmDeleteModalShow) {
      return "";
    }

    return (
      <Modal
        title={trans(this.props.trans, "autopayment.confirm.delete.title")}
        htmlDescription={trans(
          this.props.trans,
          "autopayment.delete.confirm.description"
        )}
        agreeText={trans(
          this.props.trans,
          "autopayment.confirm.delete.btn_title"
        )}
        agreeAction={() => this.deleteAutoPayment()}
        showCancelButton={true}
        cancelText={trans(
          this.props.trans,
          "autopayment.confirm.delete.cancel_btn_title"
        )}
        cancelAction={() => this.setState({ confirmDeleteModalShow: false })}
        className="modal--full"
        confirmButtonDisabled={this.state.buttonDeleteDisabled}
      />
    );
  }

  scrollToDaysList() {
    if (this.state.daysTabShow) {
      const activeItem = this.daysListRef.current.querySelector(
        ".form__date-item--active"
      );

      if (activeItem !== null) {
        this.daysListRef.current.scrollTop = activeItem.offsetTop;
      }
    }
  }

  successModal() {
    if (!this.state.successModal) {
      return "";
    }

    return (
      <Modal
        title={trans(
          this.props.trans,
          "autopayment.form_add." +
            (this.props.edit ? "edit" : "success") +
            ".title"
        )}
        description={trans(
          this.props.trans,
          "autopayment.form_add." +
            (this.props.edit ? "edit" : "success") +
            ".description"
        )}
        agreeText={trans(
          this.props.trans,
          "autopayment.form_add." +
            (this.props.edit ? "edit" : "success") +
            ".agree"
        )}
        agreeAction={() =>
          this.props.history.push(
            config.urlPrefix + this.props.parentState.urlPrefix + "/account"
          )
        }
        className="modal--full"
      />
    );
  }

  formView() {
    let phoneNumberErrorClass = "",
      phoneNumberErrorBox = "",
      cardIdErrorClass = "",
      cardIdErrorBox = "",
      nameErrorClass = "",
      nameErrorBox = "",
      amountErrorClass = "",
      amountErrorBox = "",
      dayErrorClass = "",
      dayErrorBox = "",
      serviceIdErrorClass = "",
      serviceIdErrorBox = "",
      errorBox = "";

    if (this.state.formResponse !== "") {
      if (this.state.formResponse.status === "INVALID_DATA") {
        if (this.state.formResponse.errors.hasOwnProperty("phone_number")) {
          phoneNumberErrorClass = " form-error";
          phoneNumberErrorBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.phone_number}
            </div>
          );
        }

        if (this.state.formResponse.errors.hasOwnProperty("card_id")) {
          cardIdErrorClass = " form-error";
          cardIdErrorBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.card_id}
            </div>
          );
        }

        if (this.state.formResponse.errors.hasOwnProperty("name")) {
          nameErrorClass = " form-error";
          nameErrorBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.name}
            </div>
          );
        }

        if (this.state.formResponse.errors.hasOwnProperty("amount")) {
          amountErrorClass = " form-error";
          amountErrorBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.amount}
            </div>
          );
        }

        if (this.state.formResponse.errors.hasOwnProperty("day")) {
          dayErrorClass = " form-error";
          dayErrorBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.day}
            </div>
          );
        }

        if (this.state.formResponse.errors.hasOwnProperty("service_id")) {
          serviceIdErrorClass = " form-error";
          serviceIdErrorBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.service_id}
            </div>
          );
        }
      }

      if (
        this.state.formResponse.status === "ERROR" ||
        this.state.formResponse.status === "NOT_FOUND"
      ) {
        errorBox = (
          <FormMiddlewareError message={this.state.formResponse.message} />
        );
      }
    }

    return (
      <>
        <div className="form__form-box form__form-box--text">
          <div className="form__link-conditions-out">
            <a
              className="form__link-conditions fs14"
              href={trans(
                this.props.trans,
                "autopayment.form_add.more_info_link"
              )}
              target="_blank"
              rel="noopener noreferrer"
            >
              {trans(this.props.trans, "autopayment.form_add.more_info_title")}
            </a>
          </div>
          <p className="form__conditions-text fs14">
            {trans(
              this.props.trans,
              "autopayment.form_add.more_info_description"
            )}
          </p>
        </div>

        <div className={`form__form-box${phoneNumberErrorClass}`}>
          <label
            className="form__label form__label--required db fs11"
            htmlFor="choose-phone"
          >
            {trans(this.props.trans, "autopayment.form_add.phone_label")}
          </label>
          <div className="form__field-out form__field-out--select-big pr">
            <Select
              options={this.state.autoPaymentNumbersList}
              value={this.state.numbersSelected}
              onChange={(newState) =>
                this.handleSelectChange(newState, "numbersSelected")
              }
              placeholder={trans(
                this.props.trans,
                "autopayment.form_add.phone_select_label"
              )}
              noOptionsMessage={() =>
                trans(
                  this.props.trans,
                  "autopayment.form_add.phone_select_no_options_message"
                )
              }
              isDisabled={
                (this.state.autoPaymentNumbersList === "" &&
                  this.state.autoPaymentNumbersList !== "OK") ||
                this.props.edit
              }
            />
          </div>
          {phoneNumberErrorBox}
        </div>

        <div className={`form__form-box${cardIdErrorClass}`}>
          <label
            className="form__label form__label--required db fs11"
            htmlFor="choose-card"
          >
            {trans(this.props.trans, "autopayment.form_add.card_label")}
          </label>
          <div className="form__field-out form__field-out--select-big pr">
            <Select
              options={this.state.autoPaymentCardList}
              value={this.state.cardSelected}
              onChange={(newState) =>
                this.handleSelectChange(newState, "cardSelected")
              }
              placeholder={trans(
                this.props.trans,
                "autopayment.form_add.card_select_label"
              )}
              noOptionsMessage={() =>
                trans(
                  this.props.trans,
                  "autopayment.form_add.card_select_no_options_message"
                )
              }
            />
          </div>
          {cardIdErrorBox}
        </div>

        <div className={`form__form-box${nameErrorClass}`}>
          <label
            className="form__label form__label--required db fs11"
            htmlFor="name"
          >
            {trans(this.props.trans, "autopayment.form_add.name_label")}
          </label>
          <div className="form__field-out pr">
            <input
              className="form__field fs13"
              id="name"
              type="text"
              name="name"
              value={this.state.autoPaymentName}
              onChange={(event) =>
                this.setState({ autoPaymentName: event.target.value })
              }
            />
          </div>
          {nameErrorBox}
        </div>

        {!this.state.isPostpaid ? (
          <div className="form__form-box">
            <Tab
              items={[
                {
                  title: trans(
                    this.props.trans,
                    "autopayment.form_add.tab_name1"
                  ),
                  clickCallback: () =>
                    this.setState({ autoPaymentTabIndex: 0 }),
                },
                {
                  title: trans(
                    this.props.trans,
                    "autopayment.form_add.tab_name2"
                  ),
                  clickCallback: () =>
                    this.setState({ autoPaymentTabIndex: 1 }),
                },
              ]}
              className=" tab--small"
              index={this.state.autoPaymentTabIndex}
            />
          </div>
        ) : (
          ""
        )}

        {this.state.isPostpaid ||
        (!this.state.isPostpaid && this.state.autoPaymentTabIndex === 1) ? (
          <div className={`form__form-box${dayErrorClass}`}>
            <div className="form__label-box">
              <label
                className="form__label form__label--required ver-top-box fs11"
                htmlFor="recharge-date"
              >
                {trans(
                  this.props.trans,
                  "autopayment.form_add.recharge_date_label"
                )}
              </label>
              <div className="form__info-box-inline ver-top-box pr">
                <span className="form__info sprite db"></span>
                <div className="form__info-txt fs11 pa">
                  {trans(
                    this.props.trans,
                    "autopayment.form_add.recharge_date_hint" +
                      (this.state.autoPaymentTabIndex === 1 ? "_2" : "")
                  )}
                </div>
              </div>
            </div>
            <div className="form__field-out form__field-out--days pr">
              <input
                className={`form__field form__field--right-space2 ${
                  this.state.daysTabShow ? "form__field--btm-radius-none" : ""
                } fs13`}
                id="recharge-date"
                type="text"
                name="recharge-date"
                value={
                  isNaN(this.state.rechargeDate)
                    ? this.state.rechargeDate
                    : trans(
                        this.props.trans,
                        "autopayment.form_add.recharge_date_value"
                      ).replace(/%s/, this.state.rechargeDate)
                }
                onFocus={() =>
                  this.setState(
                    {
                      daysTabShow: true,
                    },
                    this.scrollToDaysList
                  )
                }
                readOnly={true}
              />
              <button
                className="form__date-btn sprite center-vertical"
                type="button"
                onClick={() =>
                  this.setState(
                    {
                      daysTabShow: !this.state.daysTabShow,
                    },
                    this.scrollToDaysList
                  )
                }
              ></button>
              {this.daysTab()}
            </div>
            {dayErrorBox}
          </div>
        ) : null}

        {!this.state.isPostpaid ? (
          <>
            {this.state.autoPaymentTabIndex === 0 ? (
              <div className={`form__form-box${serviceIdErrorClass}`}>
                <div className="form__label-box">
                  <label
                    className="form__label form__label--required ver-top-box fs11"
                    htmlFor="minimum-account-limit"
                  >
                    {trans(
                      this.props.trans,
                      "autopayment.form_add.account_min_label"
                    )}
                  </label>
                  <div className="form__info-box-inline ver-top-box pr">
                    <span className="form__info sprite db"></span>
                    <div className="form__info-txt fs11 pa">
                      {trans(
                        this.props.trans,
                        "autopayment.form_add.account_min_hint"
                      )}
                    </div>
                  </div>
                </div>
                <div className="form__field-out form__field-out--select-big pr">
                  <Select
                    options={this.limitOptions()}
                    value={this.state.accountLimit}
                    onChange={(newState) =>
                      this.handleSelectChange(newState, "accountLimit")
                    }
                    placeholder={trans(
                      this.props.trans,
                      "autopayment.form_add.limit_select_label"
                    )}
                    noOptionsMessage={() =>
                      trans(
                        this.props.trans,
                        "autopayment.form_add.limit_select_no_options_message"
                      )
                    }
                    isDisabled={this.state.accountLimit === null}
                  />
                </div>
                {serviceIdErrorBox}
              </div>
            ) : null}
            <div className={`form__form-box${amountErrorClass}`}>
              <label
                className="form__label form__label--required db fs11"
                htmlFor="upgrade"
              >
                {trans(
                  this.props.trans,
                  "autopayment.form_add.complement_label"
                )}
              </label>
              <div className="form__field-out pr">
                <input
                  className="form__field fs13"
                  id="upgrade"
                  type="text"
                  name="upgrade"
                  value={this.state.autoPaymentComplement}
                  onChange={(event) =>
                    this.setState({
                      autoPaymentComplement: event.target.value
                        .trim()
                        .replace(/[^\d]/g, ""),
                    })
                  }
                />
              </div>
              {amountErrorBox}
              <div className="form__details-txt fs11">
                {trans(
                  this.props.trans,
                  "autopayment.form_add.complement_note"
                )}
              </div>
            </div>
          </>
        ) : (
          <div className={`form__form-box${amountErrorClass}`}>
            <label
              className="form__label form__label--required db fs11"
              htmlFor="maximum-account-limit"
            >
              {trans(this.props.trans, "autopayment.form_add.max_limit_label")}
            </label>
            <div className="form__field-out pr">
              <input
                className="form__field fs13"
                id="maximum-account-limit"
                type="text"
                name="maximum-account-limit"
                value={this.state.autoPaymentMaxLimit}
                onChange={(event) => {
                  this.setState({
                    autoPaymentMaxLimit: event.target.value
                      .trim()
                      .replace(/[^\d]/g, ""),
                  });
                }}
              />
            </div>
            {amountErrorBox}
            <div className="form__details-txt fs11">
              {trans(this.props.trans, "autopayment.form_add.max_limit_note")}
            </div>
          </div>
        )}

        {/*
                <div className="form__form-box">
                    <div className="form__checkbox-out ver-top-box">
                        <input
                            className="form__checkbox dn"
                            id="check-conditions"
                            name="check-conditions"
                            type="checkbox"
                            checked={this.state.agreeWithTerms}
                            onChange={() => this.setState({ agreeWithTerms: !this.state.agreeWithTerms })}
                        />
                        <label className="form__check-label pr db" htmlFor="check-conditions"></label>
                    </div>
                    <div className="form__link-conditions-out ver-top-box">
                        <a
                            className="form__link-conditions fs15"
                            href={trans( this.props.trans, 'autopayment.form_add.conditions_link' )}
                            target="_blank"
                            rel="noopener noreferrer"
                        >{trans( this.props.trans, 'autopayment.form_add.conditions_title' )}</a>
                    </div>
                </div>
                */}

        {errorBox}

        {this.props.edit ? (
          <>
            <div className="form__form-box">
              <button
                className={`form__submit-btn btn btn--yellow fs17${
                  this.state.buttonDisabled ? " btn--loading" : ""
                }`}
                type="submit"
                disabled={this.state.buttonDisabled}
              >
                {trans(this.props.trans, "autopayment.form_edit.btn_title")}
              </button>
            </div>

            <button
              className="form__registration-btn btn btn--white db fs17"
              type="button"
              onClick={() =>
                this.setState({
                  confirmDeleteModalShow: true,
                })
              }
            >
              {trans(
                this.props.trans,
                "autopayment.form_edit.btn_delete_title"
              )}
            </button>
          </>
        ) : (
          <button
            className={`form__submit-btn btn btn--yellow fs17${
              this.state.buttonDisabled ? " btn--loading" : ""
            }`}
            type="submit"
            disabled={this.state.buttonDisabled}
          >
            {trans(this.props.trans, "autopayment.form_add.btn_title")}
          </button>
        )}
      </>
    );
  }

  render() {
    return (
      <div className="main-wrapper__double-list main-wrapper__double-list--max-976">
        <div className="main-wrapper__double-list-item ver-top-box">
          <section className="main-wrapper__services">
            <h2 className="main-wrapper__sub-title main-wrapper__sub-title--refresh monserrat-medium pr sprite-b">
              {trans(
                this.props.trans,
                "autopayment.form_" +
                  (this.props.edit ? "edit" : "add") +
                  ".title"
              )}
            </h2>

            <div className="form form--p24 form--bottom-radius">
              <form
                action="#"
                method="post"
                onSubmit={(event) => {
                  event.preventDefault();
                  this.sendData();
                }}
              >
                {this.state.isPostpaid === null ? (
                  <Loading withBox={true} />
                ) : (
                  this.formView()
                )}
              </form>
            </div>
          </section>
        </div>

        {this.errorModal()}
        {this.successModal()}
        {this.confirmDeleteModal()}
      </div>
    );
  }
}

export default withRouter(AutoPayment);
